import {createSlice} from '@reduxjs/toolkit';
import {API} from '../constants';
import {
    ACCOUNTING_AREA_ID_MARKER,
    processRequestForAccountingAreaWithReplacement
} from './network/managedRequestForAccountingArea';
import {PbDispatch} from './index';
import {PbRequest} from './pbRequest';
import {PbGenericListApiDto} from "./pbRequestSlice";

type SerialNumberResponse = {
    number: string;
    type: 'HUB' | 'CLIENT';
    connected: boolean;
}[];

interface SerialNumberState {
    routerSerialNumbers: SerialNumberResponse;
    switchSerialNumbers: SerialNumberResponse;
    connectedSwitchSerialNumbers: SerialNumberResponse;
}

const initialState: SerialNumberState = {
    routerSerialNumbers: [],
    switchSerialNumbers: [],
    connectedSwitchSerialNumbers: [],
};

export const serialNumbersSlice = createSlice({
    name: 'serialNumbers',
    initialState,
    reducers: {
        setRouterSerialNumbers(state, action) {
            state.routerSerialNumbers = action.payload;
        },
        setSwitchSerialNumbers(state, action) {
            state.switchSerialNumbers = action.payload;
        },
        setConnectedSwitchSerialNumbers(state, action) {
            state.connectedSwitchSerialNumbers = action.payload;
        },
    },
});

export function LoadRouterSerialNumbers() {
    return async (dispatch: PbDispatch) => {
        const request = {method: 'GET'};
        const response =
            await processRequestForAccountingAreaWithReplacement<PbGenericListApiDto<SerialNumberResponse>>(
                dispatch,
                `${API}/${ACCOUNTING_AREA_ID_MARKER}/router-serial-numbers`,
                request,
                PbRequest.GET_ROUTER_SERIAL_NUMBERS
            );

        dispatch(serialNumbersSlice.actions.setRouterSerialNumbers(response.list));
    }
}

export function LoadSwitchSerialNumbers(locationId: number) {
    return async (dispatch: PbDispatch) => {
        const request = { method: 'GET' };

        const response =
            await processRequestForAccountingAreaWithReplacement<PbGenericListApiDto<SerialNumberResponse>>(
                dispatch,
                `${API}/${ACCOUNTING_AREA_ID_MARKER}/locations/${locationId}/switch-serial-numbers`,
                request,
                PbRequest.GET_SWITCH_SERIAL_NUMBERS
            );

        dispatch(serialNumbersSlice.actions.setSwitchSerialNumbers(response.list));
    };
}

export function LoadConnectedSwitchSerialNumbers(locationId: number, forceRefresh: boolean = false) {
    return async (dispatch: PbDispatch) => {
        const request = {method: 'GET'};

        const response =
            await processRequestForAccountingAreaWithReplacement<PbGenericListApiDto<SerialNumberResponse>>(
                dispatch,
                `${API}/${ACCOUNTING_AREA_ID_MARKER}/locations/${locationId}/connected-switch-serial-numbers?forceRefresh=${forceRefresh}`,
                request,
                PbRequest.GET_CONNECTED_SWITCH_SERIAL_NUMBERS
            );

        dispatch(serialNumbersSlice.actions.setConnectedSwitchSerialNumbers(response.list));
    };
}

export default serialNumbersSlice.reducer;
